/**
 * The handful of Ionicons the app's workout page uses, drawn inline for the
 * shared-workout page (play-circle, time, barbell, chevrons, close, document).
 */
import React from 'react';

type Props = { size?: number };

const Svg = ({ size = 20, children }: Props & { children: React.ReactNode }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden focusable="false">
        {children}
    </svg>
);

const stroke = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };

export const PlayCircle = ({ size }: Props) => (
    <Svg size={size}>
        <circle cx="12" cy="12" r="11" fill="currentColor" />
        <path d="M9.75 7.6v8.8a.6.6 0 0 0 .9.52l7.1-4.4a.6.6 0 0 0 0-1.04l-7.1-4.4a.6.6 0 0 0-.9.52z" fill="#fff" />
    </Svg>
);

export const TimeOutline = ({ size }: Props) => (
    <Svg size={size}>
        <circle cx="12" cy="12" r="9" {...stroke} />
        <path d="M12 7v5.5l3.5 2" {...stroke} />
    </Svg>
);

export const BarbellOutline = ({ size }: Props) => (
    <Svg size={size}>
        <path d="M2.5 12h19M5.5 8v8M8.5 6v12M15.5 6v12M18.5 8v8" {...stroke} />
    </Svg>
);

export const ChevronDown = ({ size }: Props) => (
    <Svg size={size}><path d="M6 9.5l6 6 6-6" {...stroke} /></Svg>
);

export const ChevronUp = ({ size }: Props) => (
    <Svg size={size}><path d="M6 14.5l6-6 6 6" {...stroke} /></Svg>
);

export const Close = ({ size }: Props) => (
    <Svg size={size}><path d="M6 6l12 12M18 6L6 18" {...stroke} /></Svg>
);

export const DocumentText = ({ size }: Props) => (
    <Svg size={size}>
        <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" {...stroke} />
        <path d="M14 3v5h5M9 13h6M9 17h6" {...stroke} />
    </Svg>
);
